// extracted by mini-css-extract-plugin
export var aircallIframe = "_k2-3";
export var fabContainer = "_k2-5";
export var fabRinging = "_k2-6";
export var loadingOverlay = "_k2-4";
export var pulse = "_k2-7";
export var widgetContent = "_k2-2";
export var widgetPanel = "_k2-0";
export var widgetPanelExpanded = "_k2-1";